module.exports = __webpack_public_path__ + "img/secondpic5.c44103b4.png";